import React from 'react';
import FEATURES_CONFIG from 'config/features';

import { useTranslation } from 'react-i18next';

import { ReactComponent as IconCodEn } from 'assets/svgs/icon-cod-cart-checkout.svg';
import { ReactComponent as IconCOAD } from 'assets/svgs/icon-card-on-delivery-cart-checkout.svg';
import { ReactComponent as IconMasterCard } from 'assets/svgs/icon-mastercard-new.svg';
import { ReactComponent as IconVisa } from 'assets/svgs/icon-visa-new.svg';
import { ReactComponent as IconMpesa } from 'assets/svgs/icon-mpesa.svg';
import EasyPaisaIcon from 'assets/svgs/EasyPaisa';
import IconMada from 'assets/icon-mada.png';
import IconMeeza from 'assets/icon-meeza.png';

import { Flex, Image } from '@mafc/trolly';
import { MainContainer, OnDeliveryText, Spacer } from './PaymentMethod.style';
import { useFeature } from '@mafc/appshell';
const {
  cod,
  mada,
  meeza,
  enableMpesa,
  enableEasyPaisa,
  enableCardOnDelivery,
} = FEATURES_CONFIG.settings;

const PaymentMethod = (props: any) => {
  const { t } = useTranslation();
  const { isCart = false } = props;
  const isCardOnDelivery = useFeature('card_on_delivery').on;
  return (
    <>
      <MainContainer
        sx={{
          fontWeight: `${isCart ? 5 : 2}`,
          textAlign: `${isCart ? 'center' : 'left'}`,
        }}
      >
        {t('paymentForm.availableMethods')}
      </MainContainer>
      <Flex alignItems="center" justifyContent={`${isCart ? 'center' : 'normal'}`}>
        {mada && (
          <>
            <Image url={IconMada} name="icon-mada" height="17px" width="51px" />
            <Spacer />
          </>
        )}
        {meeza && (
          <>
            <Image url={IconMeeza} name="icon-meeza" height="24px" width="37px" />
            <Spacer />
          </>
        )}
        {enableEasyPaisa && (
          <>
            <EasyPaisaIcon />
            <Spacer />
          </>
        )}
        {!enableMpesa && (
          <>
            <IconVisa />
            <Spacer />

            <IconMasterCard />
            {cod ? null : <Spacer />}
          </>
        )}
        {cod && !enableMpesa ? (
          <OnDeliveryText>
            {' '}
            <IconCodEn height={'40px'} /> {t('order_details.payments.cash_on_delivery')}
          </OnDeliveryText>
        ) : null}
        {enableMpesa && <IconMpesa />}
        {enableCardOnDelivery && isCardOnDelivery ? (
          <OnDeliveryText>
            {' '}
            <IconCOAD height={'40px'} /> {t('cardOnDeliveryText')}
          </OnDeliveryText>
        ) : null}
      </Flex>
    </>
  );
};

export default PaymentMethod;
